import React from "react";
import Image from "next/image";
import styles from "./UserProfile.module.scss";
import { LogOut } from "lucide-react";
import NavbarList from "@/domains/profile/components/sidebar-nav-list";
import { logout } from "@/domains/auth/actions";
import { useTranslations } from "next-intl";
import { useStore } from "@/hooks/use-store";
import { useMediaQuery } from "@mui/material";
import DepositModal from "@/components/Modal/Deposit/DepositModal";
import getSymbolFromCurrency from "currency-symbol-map";

const UserProfile = () => {
  const { user, modal, modalSheet } = useStore();

  const isTabletOrMobile = useMediaQuery("only screen and (max-width: 1024px)");

  const handlerProfileMenu = () => {
    if (isTabletOrMobile) {
      modalSheet.showMenu("wallet");
    }
  };

  const onLogout = () => {
    logout();
    user.logout();
    modalSheet.closeMenu();
  };

  const t = useTranslations("ProfileSideNav");

  return (
    <div className={styles.header}>
      <div className={styles.header__content}>
        <ul className={styles.header__list}>
          <li className={styles.balance} onClick={() => modal.showModal(<DepositModal />)}>
            <div data-test="user-top-balance" className={styles.balanceLink}>
              {user.user?.balance.amount || 0}&nbsp;
              <span className={styles.balanceCurrency}>
                {getSymbolFromCurrency(user.user?.balance.currency || "EUR")}
              </span>
            </div>
            <button data-test="main_deposit" className={styles.depositButton}>
              {isTabletOrMobile ? (
                <span className={styles.depositButtonInner}>
                  <svg
                    viewBox="0 0 17 12"
                    fill="currentColor"
                    width="18"
                    height="100%"
                    className={styles.button__icon}
                  >
                    <use href="/images/sprite.svg#plus"></use>
                  </svg>
                </span>
              ) : (
                <span className={styles.depositButtonInner}>Депозит</span>
              )}
            </button>
          </li>
          {/* Профиль пользователя */}
          <li className={styles.profile}>
            <div
              onClick={handlerProfileMenu}
              data-test="top-profile"
              className={styles.profileLink}
            >
              <div className={styles.profileImageWrapper}>
                <Image
                  width={37}
                  height={37}
                  src="/images/image.png"
                  alt="user"
                  className={styles.profileImage}
                />
              </div>
              <div className={styles.profileInfo}>
                <span className={styles.profileName}>{user.user?.profile.firstName || "User"}</span>
                {/* <div className={styles.progressContainer}>
                  <div className={styles.progressBar}>
                    <div className={styles.progress}>
                      <div className={styles.progressFill} style={{ width: "50%" }}>
                        <span>50%</span>
                      </div>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
            {/* Hoverable Navigation */}
            <div className={styles.containerI}>
              <NavbarList />
              <footer className={styles.containerFooter}>
                <button className={styles.buttonFooter} onClick={onLogout}>
                  <LogOut size={24} className={styles.buttonIconFooter} />
                  <span className={styles.buttonTextFooter}>{t("logout")}</span>
                </button>
              </footer>
            </div>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default UserProfile;
